module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAAAXNSR0IArs4c6QAAAUZJREFUSEvtlj1LA0EURc9dUtgIYpft0mqjthY2VopgfoEgZHfTKTZis52QQtswQY3iD7ASwVJsxVRWFiLWNtoYcJ+sxK8QiLumM68beO/McGe4dwTgnNsAtoDxdJ2jHoHtMAx35JxbBk6ABLgBXjMCC8BkZ6acAveBVTMLoyhqZIS9tzvn1oFd4CAFHgIrkqaDIGjlBM4AV8DRQICNRmPKzK6HwPyXMtTw7w97qOG/1dDMFs0sdezMJWlC0ukP+8pM6T3wZbDAUydX8rJHgeNPx06SpFStVu/y0pxzaXy0+gLjOPaKxWJNUsnzvLVKpfLQa9NfA+v1+qzneZcpRFItCILNfsCPGJ2Louiiu7nZbI612+00gHxgKQzD8+6eOI4Lvu/fA2ffg/7WzPYkvXQPSCokSTIi6bnH6SRp3swWgLIG/RV5A0qlNWScPeRTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone-icon.png
// module id = i/No
// module chunks = 1